<p-multiSelect #multiSelect styleClass="no-padd sub-dropdown mr-4"
    optionDisabled="inactive" optionLabel="name" scrollHeight="auto"
    [options]="allTypes" [(ngModel)]="selectedTypes" [filter]="false" [showToggleAll]="false" placeholder="Type">
    <ng-template pTemplate="footer">
    <button (click)="onTypeChange(multiSelect)" class="apply-button">Apply</button>
    </ng-template>
</p-multiSelect>